import { v4 as uuid } from 'uuid';
import { setAuthenticated, setInitialized } from '../base/actions';
import { refreshProfileTempSuccess } from './actions';
import { AuthenticationActions } from '../base';

// REFRESH
const refreshSuccess = (result) => (dispatch) => {
    dispatch(setAuthenticated(true));
    dispatch(refreshProfileTempSuccess(result));

    dispatch(setInitialized(true, 'refresh success'));

    return Promise.resolve(result);
};

const refreshAuth = (forceRefresh) => (dispatch, getState) => {
    const { xDeviceId } = getState().Authentication;

    if (xDeviceId && !forceRefresh) {
        const res = {
            xDeviceId,
        };

        return dispatch(refreshSuccess(res));
    }

    const profilTempId = uuid();

    return dispatch(refreshSuccess({ xDeviceId: profilTempId }));
};

// LOGOUT
const logout = (reason) => (dispatch) => {
    dispatch(AuthenticationActions.setInitialized(false, 'logout'));
    dispatch(AuthenticationActions.logout(reason));
    dispatch(refreshSuccess({ xDeviceId: uuid() }));
};

export { refreshAuth, logout };
